<template>
	<vx-card no-shadow card-border class="mt-1">
		<vs-list-item
			:title="`${$t('Waypoint')} ${indexWaypoint}`"
			:subtitle="`${waypointItem.cy}, ${waypointItem.cx}`"
		>
			<template slot="avatar">
				<vs-avatar color="success" icon-pack="feather" icon="icon-map-pin" />
			</template>
			<vs-chip class="font-bold" color="warning">{{ waypointItem.job_type | lowerCase }}</vs-chip>
		</vs-list-item>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
	components: {
		vSelect,
		VuePerfectScrollbar,
		flatPickr,
	},
	props: {
		waypointItem: {
			type: Object,
			default: () => {},
		},
		indexWaypoint: {
			type: Number,
			default: () => 0,
		},
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
	transform: translateX(200px);
	opacity: 0;
}
</style>
